// extracted by mini-css-extract-plugin
export default {"drawerContent":"DetailsPanel_drawerContent__4vVj9","drawer":"DetailsPanel_drawer__FmDgE"};